<section class="ipe-page" [class.ipe-panel-collapsed]="!isFilterPanelOpen">
  <div class="container-fluid ipe-shell">
    <div class="row ipe-row">
      <!-- Left: Filter (same area, same component) -->
      <div class="ipe-side-col"
        [class.col-12]="isFilterPanelOpen"
        [class.col-md-5]="isFilterPanelOpen"
        [class.col-lg-4]="isFilterPanelOpen"
        [class.col-xl-3]="isFilterPanelOpen"
        [class.ipe-side-col-hidden]="!isFilterPanelOpen"
        *ngIf="isFilterPanelOpen">
        <form [formGroup]="IPEMARKSForm" class="ipe-side-form">
          <div class="ipe-side-panel">
            <div class="ipe-side-header">
              <h5>Select IPE Marks Details</h5>
              <button type="button" class="ipe-panel-toggle" (click)="toggleFilterPanel()"
                title="Close filter panel" aria-label="Close filter panel">
                <i class="fa fa-times d-md-none"></i>
                <i class="fa fa-angle-double-left d-none d-md-inline"></i>
              </button>
            </div>

            <div class="ipe-side-body ipe-filter-body">
              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Academic Year</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedAcademicYear || 'Select Academic Year'">
                    <span class="ipe-filter-dropdown-text">{{ selectedAcademicYear || 'Select Academic Year' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Academic Year"
                        [(ngModel)]="academicYearQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterAcademicYears()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredAcademicYearList?.length">No Academic Year</div>
                      <ng-container *ngFor="let item of filteredAcademicYearList">
                        <ul class="ipe-dd-item" (click)="selectAcademicYear(item)"
                          [class.ipe-dd-selected]="selectedAcademicYear === getAcademicYearLabel(item)"
                          [attr.title]="getAcademicYearLabel(item)">
                          <li class="ipe-dd-text">{{ getAcademicYearLabel(item) }}</li>
                          <li><i *ngIf="selectedAcademicYear === getAcademicYearLabel(item)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Class</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedClassName || 'Select Class'">
                    <span class="ipe-filter-dropdown-text">{{ selectedClassName || 'Select Class' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Class"
                        [(ngModel)]="classQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterClasses()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredClassList?.length">No Class</div>
                      <ng-container *ngFor="let item of filteredClassList">
                        <ul class="ipe-dd-item" (click)="selectClass(item)"
                          [class.ipe-dd-selected]="selectedClassName === getClassLabel(item)"
                          [attr.title]="getClassLabel(item)">
                          <li class="ipe-dd-text">{{ getClassLabel(item) }}</li>
                          <li><i *ngIf="selectedClassName === getClassLabel(item)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Group</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedGroupName || 'Select Group'">
                    <span class="ipe-filter-dropdown-text">{{ selectedGroupName || 'Select Group' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Group"
                        [(ngModel)]="groupQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterGroups()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredGroupList?.length">No Group</div>
                      <ng-container *ngFor="let item of filteredGroupList">
                        <ul class="ipe-dd-item" (click)="selectGroup(item)"
                          [class.ipe-dd-selected]="selectedGroupName === getGroupLabel(item)"
                          [attr.title]="getGroupLabel(item)">
                          <li class="ipe-dd-text">{{ getGroupLabel(item) }}</li>
                          <li><i *ngIf="selectedGroupName === getGroupLabel(item)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Stream</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedStreamName || 'Select Stream'">
                    <span class="ipe-filter-dropdown-text">{{ selectedStreamName || 'Select Stream' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Stream"
                        [(ngModel)]="streamQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterStreams()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredStreamList?.length">No Stream</div>
                      <ng-container *ngFor="let item of filteredStreamList">
                        <ul class="ipe-dd-item" (click)="selectStream(item)"
                          [class.ipe-dd-selected]="selectedStreamName === getStreamLabel(item)"
                          [attr.title]="getStreamLabel(item)">
                          <li class="ipe-dd-text">{{ getStreamLabel(item) }}</li>
                          <li><i *ngIf="selectedStreamName === getStreamLabel(item)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Program</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedProgramName || 'Select Program'">
                    <span class="ipe-filter-dropdown-text">{{ selectedProgramName || 'Select Program' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Program"
                        [(ngModel)]="programQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterPrograms()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredProgramList?.length">No Program</div>
                      <ng-container *ngFor="let item of filteredProgramList">
                        <ul class="ipe-dd-item" (click)="selectProgram(item)"
                          [class.ipe-dd-selected]="selectedProgramName === getProgramLabel(item)"
                          [attr.title]="getProgramLabel(item)">
                          <li class="ipe-dd-text">{{ getProgramLabel(item) }}</li>
                          <li><i *ngIf="selectedProgramName === getProgramLabel(item)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Test Type</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedTestTypeLabel || 'Select Test Type'">
                    <span class="ipe-filter-dropdown-text">{{ selectedTestTypeLabel || 'Select Test Type' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Test Type"
                        [(ngModel)]="testTypeQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterTestTypes()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredTestTypeList?.length">No Test Type</div>
                      <ng-container *ngFor="let item of filteredTestTypeList">
                        <ul class="ipe-dd-item" (click)="selectTestType(item)"
                          [class.ipe-dd-selected]="selectedTestTypeLabel === getTestTypeLabel(item)"
                          [attr.title]="getTestTypeLabel(item)">
                          <li class="ipe-dd-text">{{ getTestTypeLabel(item) }}</li>
                          <li><i *ngIf="selectedTestTypeLabel === getTestTypeLabel(item)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Test Name</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedtestname || 'Select Test'">
                    <span class="ipe-filter-dropdown-text">{{ selectedtestname || 'Select Test' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Test Name"
                        [(ngModel)]="testQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterTests()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="!filteredTestList?.length">No Test</div>
                      <ng-container *ngFor="let test of filteredTestList">
                        <ul class="ipe-dd-item" (click)="selectTest(test)"
                          [class.ipe-dd-selected]="selectedTestCode === (test.testCode || test.testId || test.id)"
                          [attr.title]="getApiTestDisplayName(test)">
                          <li class="ipe-dd-text">{{ getApiTestDisplayName(test) }}</li>
                          <li><i *ngIf="selectedTestCode === (test.testCode || test.testId || test.id)" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Building Name</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.title]="selectedBuildingName || 'Select Building Name'">
                    <span class="ipe-filter-dropdown-text">{{ selectedBuildingName || 'Select Building Name' }}</span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Building"
                        [(ngModel)]="buildingQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterBuildings()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <ng-container *ngFor="let b of filteredBuildingList">
                        <ul class="ipe-dd-item" (click)="selectBuilding(b)"
                          [class.ipe-dd-selected]="buildingId == b.buildingId"
                          [attr.title]="b.buildingName">
                          <li class="ipe-dd-text">{{ b.buildingName }}</li>
                          <li><i *ngIf="buildingId == b.buildingId" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="ipe-filter-field">
                <label class="ipe-filter-label">Section</label>
                <div class="dropdown w-100">
                  <button type="button"
                    class="ipe-filter-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    [class.ipe-filter-dropdown-empty]="noSectionFound"
                    [attr.title]="selectedSectionName || (noSectionFound ? 'No Section' : 'Select Section')">
                    <span class="ipe-filter-dropdown-text" [class.ipe-no-section]="noSectionFound">
                      {{ selectedSectionName || (noSectionFound ? 'No Section' : 'Select Section') }}
                    </span>
                  </button>
                  <ul class="dropdown-menu w-100 ipe-inline-dropdown-menu">
                    <li class="ipe-dd-search" *ngIf="!noSectionFound">
                      <input type="text" class="form-control ipe-filter-input" placeholder="Search Section"
                        [(ngModel)]="sectionQuery" [ngModelOptions]="{standalone: true}"
                        (keyup)="filterSections()" (click)="$event.stopPropagation()">
                    </li>
                    <li class="ipe-dd-list">
                      <div class="ipe-dd-empty" *ngIf="noSectionFound || !filteredSectionList?.length">No Section</div>
                      <ng-container *ngFor="let s of filteredSectionList">
                        <ul class="ipe-dd-item" (click)="selectSection(s)"
                          [class.ipe-dd-selected]="selectedSectionId == s.sectionId"
                          [attr.title]="s.sectionName">
                          <li class="ipe-dd-text">{{ s.sectionName }}</li>
                          <li><i *ngIf="selectedSectionId == s.sectionId" class="fa fa-check"></i></li>
                        </ul>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="ipe-side-actions">
              <button type="button" class="ipe-side-search-btn" (click)="onFilterSearch()">Search</button>
            </div>
          </div>
        </form>
      </div>

      <!-- Right: Marks table -->
      <div class="ipe-main-col"
        [class.col-12]="true"
        [class.col-md-7]="isFilterPanelOpen"
        [class.col-lg-8]="isFilterPanelOpen"
        [class.col-xl-9]="isFilterPanelOpen"
        [class.ipe-main-expanded]="!isFilterPanelOpen">
        <div class="ipe-main-panel">
          <div class="ipe-toolbar">
            <div class="ipe-toolbar-left">
              <button type="button" class="ipe-panel-open-btn" *ngIf="!isFilterPanelOpen"
                (click)="toggleFilterPanel()" title="Open filter panel" aria-label="Open filter panel">
                <i class="fa fa-filter d-md-none"></i>
                <i class="fa fa-angle-double-right d-none d-md-inline"></i>
                <span>Filter</span>
              </button>
              <span class="ipe-toolbar-title">Student Marks Entry</span>
              <div class="ipe-count-pills" *ngIf="IPEmarks">
                <span class="ipe-student-count ipe-count-total">
                  Total Students: <strong>{{ totalStudentCount }}</strong>
                </span>
                <span class="ipe-student-count ipe-count-entered">
                  Marks Entry: <strong>{{ marksEntryStudentCount }}</strong>
                </span>
                <span class="ipe-student-count ipe-count-pending">
                  Pending: <strong>{{ pendingStudentCount }}</strong>
                </span>
              </div>
              <div class="ipe-search-wrap" *ngIf="IPEmarks">
                <i class="fa fa-search"></i>
                <input type="text" class="ipe-search-input" placeholder="Search student..."
                  (keyup)="applyFilter($event)">
              </div>
            </div>
            <div class="ipe-toolbar-actions">
              <button type="button" class="ipe-action-btn ipe-action-adm" (click)="openmarksfilterdialog1()">
                <i class="fa fa-id-card"></i> Search By Adm No
              </button>
            </div>
          </div>

          <div class="ipe-table-scroll" [style.height]="IPEmarks ? tableHeight : null"
            [style.overflow-y]="IPEmarks && dataSource.filteredData.length * 36 + 100 > 700 ? 'auto' : 'hidden'">
            <ng-container *ngIf="IPEmarks; else noData">
              <table mat-table [dataSource]="dataSource" matSort class="ipe-table"
                (matSortChange)="onSortChange()">
                <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                  <th mat-header-cell *matHeaderCellDef sticky
                    [mat-sort-header]="column"
                    [disabled]="!isSortableColumn(column)">
                    <div class="ipe-th-inner" [class.ipe-th-sortable]="isSortableColumn(column)">
                      <div class="ipe-th-main" *ngIf="!isSortableColumn(column); else sortHeader">
                        <div class="ipe-th-left">
                          <div class="ipe-th-name">{{ displayLabels[column]?.subjectName || column }}</div>
                          <div class="ipe-th-max" *ngIf="displayLabels[column]?.maxMarks">
                            {{ displayLabels[column]?.maxMarks }}
                          </div>
                        </div>
                        <label class="ipe-nc-header"
                          *ngIf="displayLabels[column]?.maxMarks !== 'Max : 0'"
                          (click)="$event.stopPropagation()">
                          <span>NC</span>
                          <input type="checkbox"
                            [checked]="isSubjectSelected(column)"
                            (change)="onNcHeaderToggle(column, $event)"
                            [attr.aria-label]="'Mark ' + column + ' as NC for all students'" />
                        </label>
                      </div>
                      <ng-template #sortHeader>
                        <div class="ipe-th-name">{{ displayLabels[column]?.subjectName || column }}</div>
                        <i class="fa ipe-sort-icon"
                          [ngClass]="getSortIconClass(column)" aria-hidden="true"></i>
                      </ng-template>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let row"
                    [class.ipe-td-identity]="column === 'admNo' || column === 'studentName'">
                    <ng-container *ngIf="column === 'admNo' || column === 'studentName'">
                      <span class="ipe-cell-text">{{ row[column] }}</span>
                    </ng-container>

                    <ng-container *ngIf="column !== 'admNo' && column !== 'studentName'">
                      <div class="ipe-marks-cell">
                        <input #inputRefs type="text" class="form-control ipe-marks-input"
                          [class.ipe-marks-text-left]="isTextMark(row[column]?.marks)"
                          [attr.data-adm-no]="row.admNo" [attr.data-subject]="column"
                          [(ngModel)]="row[column].marks" [placeholder]="column + ' Marks'"
                          [attr.max]="getMaxMarks(column)" (input)="onMarksInput(row, column)"
                          (keydown)="restrictInvalidCharacters($event)"
                          maxlength="{{ getMaxLength(column) }}"
                          [readonly]="displayLabels[column]?.maxMarks === 'Max : 0' || isSubjectSelected(column)" />
                        <span class="ipe-max-error" *ngIf="isExceedingMaxMarks(row, column)">
                          Max marks for {{ column }} is {{ getMaxMarks(column) }}
                        </span>
                      </div>
                    </ng-container>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="ipe-row"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell not_matchdata" [attr.colspan]="displayedColumns.length">
                    No data matching the filter
                  </td>
                </tr>
              </table>

              <div class="ipe-submit-bar" *ngIf="IPEmarks">
                <button type="button" class="ipe-submit-btn"
                  [disabled]="!canSubmitMarks"
                  [title]="submitMarksTitle"
                  (click)="submitMarks()">
                  <i class="fa fa-check"></i> Submit
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #noData>
  <div class="ipe-nodata">
    <figure class="mb-0">
      <img src="../../../../assets/image/nodata.png" alt="nodata" class="nodata">
    </figure>
    <p class="no_data">No Data Found</p>
  </div>
</ng-template>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
